import * as React from 'react';
import React__default, { useCallback, useMemo, useState, useEffect, Fragment } from 'react';
import { Heading, Checkbox, Tag, ButtonWithDropdown, Container } from '@grandvisionhq/elements';
import algoliaSearch from 'algoliasearch/lite';
import classnames from 'classnames';
import FocusTrap from 'focus-trap-react';
import { motion, AnimatePresence } from 'framer-motion';
import { connectStateResults, InstantSearch, Configure, Index, connectSortBy, connectRefinementList as connectRefinementList$1, connectRange as connectRange$1, connectSearchBox as connectSearchBox$1 } from 'react-instantsearch-dom';
export { InstantSearch } from 'react-instantsearch-dom';
import { IconButton, Util, MediaQuery, LockBodyScroll, Backdrop, SimpleRangeSlider, Button, Price, Expandable, RichTextArea, InfinitePagination } from '@grandvisionhq/common';
import { useIntl, useFeatureToggles, withIntl } from '@grandvisionhq/state';
import { connectSearchBox, connectRefinementList, connectRange, connectCurrentRefinements, connectStats, Configure as Configure$1, connectStateResults as connectStateResults$1 } from 'react-instantsearch-core';
import { Icon } from '@grandvisionhq/icons';
import { AlgoliaAnalyticsHelpers, AlgoliaAnalyticsTypes, ProductsSd, DataLayer } from '@grandvisionhq/analytics';
import { CommerceToolsApi } from '@grandvisionhq/commercetools';
import { getNestedProperty, getFrontImage, getLocalizedValue, getAttrValue, useDebouncedEffect, LocaleUtils, withLazyLoading, replaceWhitespace } from '@grandvisionhq/utils';
import { Util as Util$1 } from '@grandvisionhq/stores-v2';
import ReactDOM from 'react-dom';
import orderBy from 'lodash/orderBy';
import useOnClickOutside from 'use-onclickoutside';
import uniqBy from 'lodash/uniqBy';
import { findResultsState } from 'react-instantsearch-dom/server';
import merge from 'lodash/merge';
import { decode } from 'querystring';
import flowRight from 'lodash/flowRight';
import packageInfo from 'search-insights/package.json';
import algoliaSearch$1 from 'algoliasearch';
import { ProductListing, Helpers, useProductDetailContext, createImpressionEvent, createInteractionEvent, ProductBannerView } from '@grandvisionhq/products';
import isEqual from 'lodash/isEqual';
import isPlainObject from 'lodash/isPlainObject';

function NoResults(_a) {
    var _b = _a.description, description = _b === void 0 ? '' : _b, _c = _a.title, title = _c === void 0 ? '' : _c, _d = _a.query, query = _d === void 0 ? '' : _d;
    return (React.createElement("div", { className: "no-results" },
        React.createElement(Heading, { variant: "medium", className: "no-results__title" }, title),
        React.createElement("p", { className: "no-results__description" }, description.replace('{{searchQuery}}', "\"" + query + "\""))));
}

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.
Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.
THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}
function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || from);
}

var SearchBox = function (_a) {
    var currentRefinement = _a.currentRefinement, handleFocus = _a.handleFocus, handleClose = _a.handleClose, handleSubmit = _a.handleSubmit, hasFocus = _a.hasFocus, refine = _a.refine, _b = _a.forceFocus, forceFocus = _b === void 0 ? false : _b;
    var getLabel = useIntl().getLabel;
    var inputRef = React.useRef(null);
    React.useEffect(function () {
        if (forceFocus) {
            if (inputRef.current) {
                inputRef.current.focus();
            }
            if (document.activeElement !== inputRef.current) {
                handleFocus();
            }
        }
    }, [forceFocus]);
    var handleSearch = function (event) {
        var value = event.currentTarget.value;
        if (refine) {
            refine(value);
        }
    };
    var onSubmit = function () {
        if (currentRefinement && currentRefinement.length >= 2) {
            handleSubmit(currentRefinement, 'products');
        }
    };
    var handleClearInput = function () {
        if (refine) {
            refine('');
        }
    };
    var handleKeyUp = function (event) {
        if (event.key === 'Enter') {
            onSubmit();
        }
    };
    var handleBlur = function (e) {
        var target = e === null || e === void 0 ? void 0 : e.relatedTarget;
        var excludedItemClicked = target &&
            target instanceof HTMLElement &&
            ['a', 'button'].includes(target.tagName.toLowerCase());
        if (!currentRefinement && !excludedItemClicked) {
            handleClose();
        }
    };
    var searchBoxClass = classnames('search-box', {
        'search-box--focus': hasFocus,
    });
    var inputClass = classnames('search-box__input', {
        'search-box__input--focus': hasFocus,
    });
    var searchIconClass = classnames('search-box-icons__search', {
        'search-box-icons__search--active': currentRefinement && currentRefinement.length > 0,
        'search-box-icons__search--focus': hasFocus,
    });
    var clearInputClass = classnames('search-box-icons__clear', {
        'search-box-icons__clear--active': currentRefinement && currentRefinement.length > 0,
    });
    return (React.createElement("div", { className: searchBoxClass },
        React.createElement("input", { className: inputClass, type: "search", onBlur: handleBlur, onFocus: handleFocus, onSubmit: onSubmit, onChange: handleSearch, onKeyUp: handleKeyUp, placeholder: getLabel('search.searchField.placeholder'), value: currentRefinement, ref: inputRef, "data-t": "search-box" }),
        React.createElement("div", { className: "search-box-icons" },
            React.createElement("button", { "aria-label": getLabel('common.actions.search'), className: searchIconClass, onClick: onSubmit, type: "submit" },
                React.createElement(Icon, { name: "search" })),
            React.createElement("div", { className: "search-box-icons__actions" },
                React.createElement("button", { className: clearInputClass, onClick: handleClearInput }, getLabel('search.searchField.clear')),
                React.createElement(IconButton, { className: "search-box-icons__close", "aria-label": getLabel('common.actions.close'), onClick: handleClose },
                    React.createElement(Icon, { name: "close" }))))));
};
var SearchBox$1 = connectSearchBox(SearchBox);

var ContentSuggestion = function (_a) {
    var suggestion = _a.suggestion, onClick = _a.onClick;
    if (!suggestion.link || !suggestion.title || suggestion.link === '' || suggestion.title === '') {
        return null;
    }
    return (React.createElement("a", { className: "content-suggestion__link", href: suggestion.link, onClick: function () { return onClick && onClick(suggestion.objectID, suggestion.position); } },
        React.createElement("span", { className: "content-suggestion__icon-wrapper" },
            React.createElement(Icon, { name: "content", className: "content-suggestion__content-icon" })),
        React.createElement("span", { className: "content-suggestion--wrap-text" }, Util.truncateString(suggestion.title, 60))));
};

var ProductSuggestion = function (_a) {
    var productUrl = _a.productUrl, isContactLens = _a.isContactLens, onClick = _a.onClick, brand = _a.brand, name = _a.name, imageUrl = _a.imageUrl;
    return (React.createElement("div", { className: "product-suggestion" },
        React.createElement("a", { className: "product-suggestion__link", href: productUrl, onClick: onClick },
            React.createElement("span", { className: "product-suggestion__image-holder" },
                React.createElement("img", { className: "product-suggestion__image", src: imageUrl, alt: brand })),
            React.createElement("span", { className: "product-suggestion__name-holder" },
                !isContactLens && React.createElement("span", null,
                    brand,
                    " "),
                React.createElement("span", { className: "product-suggestion__name" }, name)))));
};

function getProductImageUrl(suggestion, isBynderImagesEnabled, staticsUrl) {
    var _a, _b;
    if (isBynderImagesEnabled === void 0) { isBynderImagesEnabled = false; }
    if (staticsUrl === void 0) { staticsUrl = ''; }
    if (isBynderImagesEnabled) {
        var images_1 = getNestedProperty(suggestion, 'masterVariant.media.images', []);
        var imageUrl_1 = getFrontImage(images_1).url;
        return imageUrl_1 + "?w=75&auto=format";
    }
    var images = getNestedProperty(suggestion, 'masterVariant.images', []);
    var imageUrl = (_b = (_a = images[0]) === null || _a === void 0 ? void 0 : _a.url) !== null && _b !== void 0 ? _b : '';
    return imageUrl && "" + staticsUrl + imageUrl + "?w=75&auto=format";
}

var ProductSuggestionContainer = function (_a) {
    var formatProductUrl = _a.formatProductUrl, staticsUrl = _a.staticsUrl, suggestion = _a.suggestion, onClick = _a.onClick;
    var locale = useIntl().locale;
    var isBynderImagesEnabled = useFeatureToggles().isBynderImagesEnabled;
    var props = React.useMemo(function () {
        var _a;
        var productType = getNestedProperty(suggestion, 'productType.obj.name');
        var isContactLens = CommerceToolsApi.isLenses(productType) || CommerceToolsApi.isContactLensBundle(productType);
        var name = isContactLens
            ? getLocalizedValue(suggestion.name, locale)
            : (_a = suggestion.masterVariant.name) !== null && _a !== void 0 ? _a : '';
        var brand = String(getAttrValue(suggestion.masterVariant, 'brand')) || '';
        var sku = getNestedProperty(suggestion, 'masterVariant.sku');
        var slug = suggestion.slug;
        if (!brand || !name || !productType || !slug || !sku) {
            return null;
        }
        var productUrl = formatProductUrl({ productType: productType, sku: sku, slug: slug });
        var imageUrl = getProductImageUrl(suggestion, isBynderImagesEnabled, staticsUrl);
        return { isContactLens: isContactLens, name: name, brand: brand, productUrl: productUrl, imageUrl: imageUrl };
    }, [formatProductUrl, suggestion, staticsUrl, locale]);
    var onSuggestionClick = React.useCallback(function () {
        onClick && onClick(suggestion.objectID, suggestion.position);
    }, [suggestion, onClick]);
    if (!props) {
        return null;
    }
    return React.createElement(ProductSuggestion, __assign({}, props, { onClick: onSuggestionClick }));
};

var SearchSuggestion = function (_a) {
    var suggestion = _a.suggestion, targetPath = _a.targetPath, onClick = _a.onClick;
    return (React.createElement("div", { className: "search-suggestion__item" },
        React.createElement("a", { className: "search-suggestion__link", href: "" + targetPath + suggestion.query, onClick: function () { return onClick && onClick(suggestion.objectID, suggestion.position); } }, suggestion.query)));
};

var StoreSuggestion = function (_a) {
    var suggestion = _a.suggestion, targetPath = _a.targetPath, isMultilingualEnabled = _a.isMultilingualEnabled, onClick = _a.onClick;
    var locale = useIntl().locale;
    var getLocalizedValue = function (storeField, fallBackValue) {
        return isMultilingualEnabled && storeField && storeField[locale] ? storeField[locale] : fallBackValue;
    };
    var selectedStore = getLocalizedValue(suggestion.storeNameLocalized, suggestion.storeName);
    var storeDetailsUrl = Util$1.getStoreDetailUrl(targetPath)(suggestion);
    return (React.createElement("div", { className: "store-suggestion__item" },
        React.createElement("a", { "data-t": "SuggestionLink", className: "store-suggestion__link", href: storeDetailsUrl, onClick: function () { return onClick && onClick(suggestion.objectID, suggestion.position); } },
            React.createElement("span", { className: "store-suggestion__icon-wrapper" },
                React.createElement(Icon, { name: "store", className: "store-suggestion__store-icon" })),
            React.createElement("span", { className: "store-suggestion__title store-suggestion--wrap-text" }, selectedStore),
            React.createElement("span", { className: "store-suggestion__subtitle store-suggestion--wrap-text" }, getLocalizedValue(suggestion.townLocalized, suggestion.town) + ",  " + getLocalizedValue(suggestion.streetNameLocalized, suggestion.streetName) + " " + (suggestion.streetNumber || '') + " "))));
};

function SuggestionBlock(_a) {
    var title = _a.title, noResults = _a.noResults, showAll = _a.showAll, handleSubmit = _a.handleSubmit, suggestions = _a.suggestions, render = _a.render;
    return (React.createElement("div", { className: "suggestion-block" },
        React.createElement("span", { id: title, className: "suggestion-block__header" }, title),
        !suggestions || !Array.isArray(suggestions) || suggestions.length === 0 ? (React.createElement("div", { className: "suggestion-block__no-results" }, noResults)) : (React.createElement(React.Fragment, null,
            React.createElement("ul", { className: "suggestion-block__results", "aria-label": title }, suggestions.map(function (suggestion, index) {
                if (suggestion) {
                    var augmentedSuggestion = __assign(__assign({}, suggestion), { position: index + 1 });
                    return (React.createElement("li", { className: "suggestion-block__result", key: augmentedSuggestion.objectID }, render(augmentedSuggestion)));
                }
            })),
            handleSubmit && (React.createElement("button", { className: "suggestion-block__show-all", type: "button", "data-t": title, onClick: handleSubmit }, showAll))))));
}

var getResultsByIndex = function (searchResults, indexName) {
    if (!searchResults || !indexName) {
        return undefined;
    }
    if (Object.keys(searchResults).indexOf('hits') === -1) {
        return searchResults[indexName];
    }
    else if (searchResults && Object.keys(searchResults).indexOf('hits') !== -1) {
        return searchResults.index === indexName ? searchResults : undefined;
    }
};
var SearchResults = function (props) {
    var allSearchResults = props.allSearchResults, formatProductUrl = props.formatProductUrl, pageRoutes = props.pageRoutes, suggestionIndex = props.suggestionIndex, contentIndex = props.contentIndex, storeIndex = props.storeIndex, onSubmit = props.onSubmit, productIndex = props.productIndex, searchState = props.searchState, staticsUrl = props.staticsUrl, intl = props.intl, isMultilingualEnabled = props.isMultilingualEnabled;
    var query = searchState.query;
    var productSuggestions = getResultsByIndex(allSearchResults, productIndex.name);
    var querySuggestions = suggestionIndex && getResultsByIndex(allSearchResults, suggestionIndex.name);
    var storeSuggestions = storeIndex && getResultsByIndex(allSearchResults, storeIndex.name);
    var contentSuggestions = contentIndex && getResultsByIndex(allSearchResults, contentIndex.name);
    var isValidQuery = function (query) {
        if (!!query && query.length >= 2) {
            return true;
        }
        return false;
    };
    var validQuery = isValidQuery(query);
    var handleSubmit = function () {
        if (isValidQuery(query)) {
            onSubmit(query, 'products');
        }
    };
    var goToStores = function () {
        if (isValidQuery(query)) {
            onSubmit(query, 'stores');
        }
    };
    var handleClickAnalytics = React.useCallback(function (searchIndex) { return function (objectID, position) {
        var currentSearchState = getResultsByIndex(allSearchResults, searchIndex);
        if (currentSearchState === null || currentSearchState === void 0 ? void 0 : currentSearchState.queryID) {
            AlgoliaAnalyticsHelpers.clickedObjectIdsAfterSearch({
                searchIndex: searchIndex,
                queryId: currentSearchState.queryID,
                eventName: AlgoliaAnalyticsTypes.AlgoliaAnalyticsEvents.SearchSuggestionClicked,
                objectIds: objectID,
                positions: position,
            });
        }
    }; }, [allSearchResults]);
    var showAllButtonClass = classnames('search-results__show-all-button', {
        'search-results__show-all-button--active': productSuggestions && validQuery && productSuggestions.nbHits > 0,
    });
    var getStoresPath = function () {
        var pathFromPageRoutes = pageRoutes === null || pageRoutes === void 0 ? void 0 : pageRoutes.stores;
        var pathFromConfig = (storeIndex && storeIndex.targetPath) || '';
        return pathFromPageRoutes || pathFromConfig;
    };
    return (React.createElement("div", { className: "search-results" },
        querySuggestions && (React.createElement("div", { className: "search-results__suggestions search-results__query-suggestions" },
            React.createElement(SuggestionBlock, { suggestions: querySuggestions.hits, title: intl.getLabel('search.suggestions.suggestions.title'), showAll: intl.getLabel('search.showAll'), noResults: intl.getLabel('search.noResults.title'), render: function (hit) { return (React.createElement(SearchSuggestion, { key: hit.objectID, suggestion: hit, targetPath: (suggestionIndex && suggestionIndex.targetPath) || '', onClick: handleClickAnalytics(querySuggestions.index) })); } }))),
        React.createElement("div", { className: "search-results__suggestions" }, productSuggestions && validQuery && (React.createElement(SuggestionBlock, { title: intl.getLabel('search.suggestions.products.title'), showAll: intl.getLabel('search.showAll'), noResults: intl.getLabel('search.noResults.title'), handleSubmit: handleSubmit, suggestions: productSuggestions.hits, render: function (hit) { return (React.createElement(ProductSuggestionContainer, { key: hit.objectID, formatProductUrl: formatProductUrl, staticsUrl: staticsUrl, suggestion: hit, onClick: handleClickAnalytics(productSuggestions.index) })); } }))),
        React.createElement("div", { className: "search-results__suggestions" }, storeSuggestions && validQuery && (React.createElement(SuggestionBlock, { title: intl.getLabel('search.suggestions.stores.title'), showAll: intl.getLabel('search.showAll'), noResults: intl.getLabel('search.noResults.title'), handleSubmit: goToStores, suggestions: storeSuggestions.hits, render: function (hit) { return (React.createElement(StoreSuggestion, { isMultilingualEnabled: isMultilingualEnabled, key: hit.objectID, suggestion: hit, targetPath: getStoresPath(), onClick: handleClickAnalytics(storeSuggestions.index) })); } }))),
        React.createElement("div", { className: "search-results__suggestions" }, contentSuggestions && validQuery && (React.createElement(SuggestionBlock, { title: intl.getLabel('search.suggestions.content.title'), noResults: intl.getLabel('search.noResults.title'), suggestions: contentSuggestions.hits, render: function (hit) { return (React.createElement(ContentSuggestion, { key: hit.objectID, suggestion: hit, onClick: handleClickAnalytics(contentSuggestions.index) })); } }))),
        productSuggestions && validQuery && (React.createElement("div", { className: "search-results__show-all" },
            React.createElement("button", { onClick: handleSubmit, className: showAllButtonClass }, intl.getLabel('search.showAll'))))));
};
var SearchResults$1 = connectStateResults(withIntl(SearchResults));

var posedContent = {
    idle: {
        height: 0,
        overflow: 'hidden',
    },
    focusFixed: {
        height: 'auto',
        transition: { delay: 0.15, ease: 'easeIn' },
        transitionEnd: { overflow: 'auto' },
    },
    focusStatic: {
        height: 'auto',
        transition: { ease: 'easeInOut' },
        transitionEnd: { overflow: 'auto' },
    },
};
var posedSearchBar = {
    idle: {
        position: 'relative',
        top: 0,
        left: 0,
        right: 0,
        height: '100%',
        transition: { duration: 0 },
    },
    focusFixed: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        height: 74,
        transition: { type: 'tween', ease: 'circOut', duration: 0.25 },
    },
    focusStatic: {
        height: 74,
    },
};
var SearchBar = function (_a) {
    var pageRoutes = _a.pageRoutes, isMultilingualEnabled = _a.isMultilingualEnabled, formatProductUrl = _a.formatProductUrl, staticsUrl = _a.staticsUrl, onSubmit = _a.onSubmit, onClose = _a.onClose, onFocus = _a.onFocus, forceFocus = _a.forceFocus, config = _a.config, isMobile = _a.isMobile;
    var intl = useIntl();
    var currentBreakpoint = MediaQuery.useBreakpoint();
    var searchClient = algoliaSearch(config.appId, config.apiKey);
    var _b = __read(React.useState(false), 2), hasFocus = _b[0], setHasFocus = _b[1];
    var _c = __read(React.useState(), 2), pose = _c[0], setPose = _c[1];
    var productIndex = config.productIndex, _d = config.indexes, indexes = _d === void 0 ? [] : _d;
    var resultConfig = {};
    if (indexes && Array.isArray(indexes)) {
        resultConfig = indexes.reduce(function (prev, curr) {
            switch (curr.type) {
                case 'suggestions':
                    prev.suggestionIndex = curr;
                    break;
                case 'stores':
                    prev.storeIndex = curr;
                    break;
                case 'content':
                    prev.contentIndex = curr;
                    break;
            }
            return prev;
        }, {});
    }
    var isWideScreen = function () {
        return currentBreakpoint === MediaQuery.BreakpointName.TABLET_LANDSCAPE ||
            currentBreakpoint === MediaQuery.BreakpointName.DESKTOP;
    };
    var configureIndexes = function (index) {
        var localeFilter = "locale:" + intl.locale.replace('-', '_');
        var filtersWithLocaleCheck = index.filters
            ? localeFilter + " AND (" + index.filters + ")"
            : localeFilter;
        var filters = isMultilingualEnabled && index.type === 'content' ? filtersWithLocaleCheck : index.filters;
        return (React.createElement(Index, { indexName: index.name, key: index.name },
            React.createElement(Configure, { filters: filters, analytics: true })));
    };
    var handleFocus = React.useCallback(function () {
        setHasFocus(true);
        onFocus && onFocus();
        Util.lockScroll();
    }, [onFocus]);
    var handleClose = React.useCallback(function () {
        setHasFocus(false);
        onClose && onClose();
        Util.unlockScroll();
    }, [onClose]);
    var configuredIndexes = React.useMemo(function () { return indexes.map(configureIndexes); }, [indexes]);
    React.useEffect(function () {
        // Close search bar upon pressing esc
        var closeSearchBar = function (event) {
            if (event.key === 'Escape') {
                handleClose();
            }
        };
        document.addEventListener('keydown', closeSearchBar, false);
        return function () {
            document.removeEventListener('keydown', closeSearchBar, false);
        };
    }, []);
    React.useEffect(function () {
        var EMPTY = '';
        var IDLE = 'idle';
        var FOCUS_FIXED = 'focusFixed';
        var FOCUS_STATIC = 'focusStatic';
        setPose([
            IDLE,
            hasFocus && isWideScreen() ? FOCUS_FIXED : EMPTY,
            hasFocus && !isWideScreen() ? FOCUS_STATIC : EMPTY,
        ].filter(Boolean));
    }, [hasFocus, currentBreakpoint]);
    var handleKeyUp = function (event) {
        if (event.key === 'Enter') {
            handleFocus();
        }
    };
    var renderSearch = function () { return (React.createElement(FocusTrap, { active: hasFocus },
        React.createElement(InstantSearch, { searchClient: searchClient, indexName: productIndex.name },
            hasFocus && React.createElement(LockBodyScroll, null),
            React.createElement(motion.div, { role: "dialog", "aria-modal": true, "aria-label": intl.getLabel('common.actions.search'), animate: pose, className: classnames('search-bar', {
                    'search-bar--focus': hasFocus,
                }) },
                React.createElement(Configure, { hitsPerPage: 4, clickAnalytics: true, filters: productIndex.filters }),
                configuredIndexes,
                React.createElement(motion.div, { className: "search-bar__pose-container", variants: posedSearchBar, initial: "idle", animate: pose },
                    React.createElement("div", { className: "search-bar__container" },
                        React.createElement("div", { className: "search-bar__box-container" },
                            React.createElement(SearchBox$1, { hasFocus: hasFocus, handleFocus: handleFocus, handleClose: handleClose, handleSubmit: onSubmit, forceFocus: !!forceFocus })))),
                React.createElement(motion.div, { variants: posedContent, initial: "idle", animate: pose, className: "search-bar__content" },
                    React.createElement("div", { className: "search-bar__content-container" }, hasFocus && (React.createElement(SearchResults$1, { isMultilingualEnabled: isMultilingualEnabled, formatProductUrl: formatProductUrl, pageRoutes: pageRoutes, productIndex: productIndex, staticsUrl: staticsUrl, storeIndex: resultConfig.storeIndex, suggestionIndex: resultConfig.suggestionIndex, contentIndex: resultConfig.contentIndex, onSubmit: onSubmit }))),
                    React.createElement("div", { className: "search-bar__content-scroll-indicator" })),
                React.createElement(Backdrop, { className: "search-bar__backdrop", onClick: handleClose, isVisible: hasFocus, poseConfig: {
                        exit: {
                            opacity: 0,
                        },
                        enter: {
                            opacity: 1,
                            transition: {
                                delay: 0.25,
                            },
                        },
                    } }))))); };
    return (React.createElement(React.Fragment, null,
        !isMobile && (React.createElement("input", { className: "search-bar__input", onClick: handleFocus, onKeyDown: handleKeyUp, onInput: handleFocus, placeholder: intl.getLabel('search.searchField.placeholder'), "data-t": "search-bar", "aria-label": intl.getLabel('common.actions.search'), 
            // We handle this in the opened search bar
            value: "" })),
        hasFocus || forceFocus ? renderSearch() : null));
};
var SearchBar$1 = React.memo(SearchBar);

var _a;
var FacetId;
(function (FacetId) {
    // we will only list FacetId's which have a special meaning and are used in our code
    // facets to render when no productType is selected (primary facets):
    FacetId["productType"] = "productType";
    FacetId["price"] = "price";
    FacetId["brand"] = "brand";
    // facets which represent colors
    FacetId["lensColor"] = "lensColor";
    FacetId["frameColor"] = "frameColor";
    // id to recognize the commercetools category-facet
    FacetId["categoryExternalId"] = "categoryExternalId";
})(FacetId || (FacetId = {}));
var PrimaryFacets = (_a = {},
    _a[FacetId.productType] = true,
    _a[FacetId.price] = true,
    _a[FacetId.brand] = true,
    _a);
function isFacetHidden(facet) {
    return facet.hidden === true;
}
function isFacetVisible(facet) {
    return !isFacetHidden(facet);
}
function isValidAlgoliaSearchConfig(obj) {
    return Object.values(obj).every(Boolean);
}

var DEFAULT_ALGOLIA_CONFIG = {
    isEnabled: false,
    algoliaInstantSearchProps: {
        indexName: '',
        searchState: {},
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        onSearchStateChange: function () { },
        searchClient: {},
    },
    facets: [],
    pageSize: 24,
    sortIndices: [],
    presetQueryObject: {},
    ruleContexts: [],
};
var AlgoliaConfig = React.createContext(DEFAULT_ALGOLIA_CONFIG);
var useAlgoliaConfig = function () { return React.useContext(AlgoliaConfig); };

function useItemsToClear(items) {
    var facets = useAlgoliaConfig().facets;
    var visibleFacets = facets.filter(isFacetVisible);
    return items.filter(function (item) { return visibleFacets.find(function (_a) {
        var attribute = _a.attribute;
        return attribute === item.attribute;
    }); });
}

var ClearFacetFilter = function (_a) {
    var onClear = _a.onClear, _b = _a.isDisabled, isDisabled = _b === void 0 ? false : _b, label = _a.label;
    return (React.createElement("button", { className: "clear-facet-filter", onClick: onClear, disabled: isDisabled, type: "button" }, label));
};

var orderFacetOptions = function (_a) {
    var facet = _a.facet, items = _a.items;
    return facet.orderBy
        ? orderBy(items, facet.orderBy.map(function (x) { return x.attribute; }), facet.orderBy.map(function (x) { return x.direction; }))
        : items;
};

function getFacetOptionLabel(facet, itemLabel, intl) {
    var options = facet.options && facet.options[itemLabel.toLowerCase()];
    var labelFromOptions = options && (options.labelKey ? intl.getLabel(options.labelKey) : options.label);
    return {
        icon: options && options.icon,
        label: labelFromOptions || itemLabel,
    };
}

var RefinementItem = function (_a) {
    var item = _a.item, facet = _a.facet, onRefine = _a.onRefine;
    var handleChange = React.useCallback(function () { return onRefine(item.value); }, [item]);
    var intl = useIntl();
    var _b = React.useMemo(function () { return getFacetOptionLabel(facet, item.label, intl); }, [
        facet,
        item,
    ]), icon = _b.icon, label = _b.label;
    return (React.createElement("label", { className: "refinement-item" },
        React.createElement("span", { className: "refinement-item__checkbox" },
            React.createElement(Checkbox, { checked: item.isRefined, value: item.label, onChange: handleChange, "aria-label": label })),
        React.createElement("span", { className: "refinement-item__value" },
            icon && React.createElement(Icon, { name: icon }),
            " ",
            label),
        React.createElement("span", { className: "refinement-item__count" }, item.count)));
};

var FacetSearchBox = function (_a) {
    var placeholder = _a.placeholder, onSearch = _a.onSearch;
    return (React.createElement("div", { className: "facet-searchbox" },
        React.createElement("input", { className: "facet-searchbox__input", type: "search", onChange: onSearch, placeholder: placeholder, "aria-label": "Search through filter options" }),
        React.createElement(Icon, { name: "search", className: "facet-searchbox__icon" })));
};

var FacetHeaderMobile = function (_a) {
    var refineCount = _a.refineCount, onSearch = _a.onSearch, onClear = _a.onClear, intl = _a.intl, title = _a.title, isExpanded = _a.isExpanded;
    var titleClass = classnames('facet-header-mobile__title', {
        'facet-header-mobile__title--expanded': isExpanded,
    });
    return (React.createElement("div", { className: "facet-header-mobile" },
        React.createElement("div", { className: "facet-header-mobile__heading" },
            React.createElement(Heading, { variant: "smallest", className: titleClass }, title),
            isExpanded && onClear && (React.createElement(ClearFacetFilter, { onClear: onClear, isDisabled: refineCount === 0, label: intl.getLabel('search.filters.clear', {
                    defaultValue: 'clear',
                }) }))),
        isExpanded && React.createElement("span", { className: "facet-header-mobile__divider" }),
        isExpanded && onSearch && (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "facet-header-mobile__search" },
                React.createElement(FacetSearchBox, { placeholder: intl.getLabel('search.filters.placeholder'), onSearch: function (event) { return onSearch(event.target.value); } }))))));
};
var FacetHeaderMobile$1 = withIntl(FacetHeaderMobile);

var FacetContainerMobile = function (_a) {
    var children = _a.children, onClear = _a.onClear, onSearch = _a.onSearch, onShowMore = _a.onShowMore, refineCount = _a.refineCount, labels = _a.labels, isActive = _a.isActive, itemCount = _a.itemCount;
    var _b = __read(React.useState(false), 2), isExpanded = _b[0], setExpanded = _b[1];
    var handleShowMore = function () {
        onShowMore && onShowMore();
    };
    return (React.createElement("div", { className: "facet-container-mobile" },
        React.createElement(FacetHeaderMobile$1, { title: labels.title, refineCount: refineCount, onSearch: onSearch, onClear: onClear, isExpanded: !!isActive }),
        React.createElement("div", { className: "facet-container-mobile__inner" }, isExpanded || isActive ? children : React.Children.toArray(children).slice(0, 6)),
        (itemCount > 6 || isExpanded) && !isActive && (React.createElement("div", { className: "facet-container-mobile__footer" },
            itemCount > 15 && !isExpanded && (React.createElement("button", { type: "button", onClick: handleShowMore, className: "facet-container-mobile__footer-button" },
                React.createElement(Icon, { name: "search", className: "facet-container-mobile__footer-icon" }),
                labels.showMore)),
            itemCount <= 15 && (React.createElement("button", { type: "button", onClick: function () { return setExpanded(!isExpanded); }, className: "facet-container-mobile__footer-button" }, isExpanded ? (React.createElement(React.Fragment, null,
                React.createElement(Icon, { name: "chevron-up", className: "facet-container-mobile__footer-icon" }),
                labels.showLess)) : (React.createElement(React.Fragment, null,
                React.createElement(Icon, { name: "chevron-down", className: "facet-container-mobile__footer-icon" }),
                labels.showMore))))))));
};

var ConnectedFacetContainerMobile = function (_a) {
    var facet = _a.facet, attribute = _a.attribute, items = _a.items, refine = _a.refine, title = _a.title, isActive = _a.isActive, onToggle = _a.onToggle, searchable = _a.searchable, searchForItems = _a.searchForItems, isFromSearch = _a.isFromSearch, expandedState = _a.expandedState, showMoreLabel = _a.showMoreLabel, showLessLabel = _a.showLessLabel;
    var handleShowMore = useCallback(function () {
        onToggle(attribute);
    }, [attribute]);
    var labels = useMemo(function () { return ({
        title: title,
        showMore: showMoreLabel,
        showLess: showLessLabel,
    }); }, [title, showMoreLabel, showLessLabel]);
    if (!items.length && !isFromSearch) {
        return null;
    }
    var facetListClass = classnames('connected-facet-container-mobile', {
        'connected-facet-container-mobile--hidden': expandedState && !isActive,
    });
    var sortedItems = orderFacetOptions({ facet: facet, items: items });
    return (React__default.createElement("div", { className: facetListClass },
        React__default.createElement(FacetContainerMobile, { onSearch: searchable ? searchForItems : undefined, refineCount: items.filter(function (x) { return x.isRefined; }).length, onClear: handleClear, labels: labels, onShowMore: handleShowMore, isActive: isActive, itemCount: items.length }, sortedItems.map(function (item) { return (React__default.createElement(RefinementItem, { key: item.label, item: item, facet: facet, onRefine: refine })); }))));
    function handleClear() {
        refine([]);
    }
};
var ConnectedFacetContainerMobile$1 = connectRefinementList(ConnectedFacetContainerMobile);

var FacetInputPriceRange = function (_a) {
    var min = _a.min, max = _a.max, value = _a.value, onChange = _a.onChange, _b = _a.renderNumber, renderNumber = _b === void 0 ? function (v) { return v; } : _b;
    var _c = useFacetInputPriceRangeValue(value, onChange), range = _c.range, setRange = _c.setRange, dispatchRange = _c.dispatchRange;
    var _d = useIntl(), currency = _d.currency, getLabel = _d.getLabel;
    return (React__default.createElement("div", { className: "facet-input-price-range" },
        React__default.createElement(SimpleRangeSlider, { value: [range.min, range.max], min: min, max: max, currency: currency, onChange: function (_a) {
                var _b = __read(_a, 2), newMin = _b[0], newMax = _b[1];
                return setRange({ min: newMin, max: newMax });
            }, onAfterChange: dispatchRange, renderNumber: renderNumber, ariaLabel: getLabel('search.filters.pricerange.select', {
                defaultValue: 'Select a price range',
            }) })));
};
function useFacetInputPriceRangeValue(value, onChange) {
    var _a = __read(useState(value), 2), range = _a[0], setRange = _a[1];
    var dispatchRange = useCallback(function () { return onChange(range); }, [range.min, range.max]);
    useEffect(function () { return setRange(value); }, [value.min, value.max]);
    return { range: range, setRange: setRange, dispatchRange: dispatchRange };
}

var ConnectedFacetInputPriceRangeMobile = function (_a) {
    var refine = _a.refine, title = _a.title, min = _a.min, max = _a.max, showLessLabel = _a.showLessLabel, showMoreLabel = _a.showMoreLabel, currentRefinement = _a.currentRefinement, expandedState = _a.expandedState, isActive = _a.isActive;
    var clearHandler = useCallback(function () { return refine({ min: min, max: max }); }, [min, max]);
    var labels = useMemo(function () { return ({
        title: title,
        showMore: showMoreLabel,
        showLess: showLessLabel,
    }); }, [title, showMoreLabel, showLessLabel]);
    if (min === max) {
        return null;
    }
    var facetListClass = classnames('facet-input-price-range-mobile', {
        'facet-input-price-range-mobile--hidden': expandedState && !isActive,
    });
    return (React__default.createElement("div", { className: facetListClass },
        React__default.createElement(FacetContainerMobile, { onClear: clearHandler, refineCount: 0, itemCount: 0, labels: labels },
            React__default.createElement(FacetInputPriceRange, { min: min, max: max, value: currentRefinement, onChange: refine, renderNumber: function (value) { return Math.round(value / 100); } }))));
};
var ConnectedFacetInputPriceRangeMobile$1 = connectRange(ConnectedFacetInputPriceRangeMobile);

var FacetsMobile = function (_a) {
    var facets = _a.facets, items = _a.items, refine = _a.refine, nbHits = _a.nbHits;
    var getLabel = useIntl().getLabel;
    var _b = __read(useState(false), 2), hasMounted = _b[0], setMounted = _b[1];
    var _c = __read(useState(), 2), activeFacet = _c[0], setActiveFacet = _c[1];
    var _d = __read(useState(false), 2), isVisible = _d[0], setVisible = _d[1];
    var _e = __read(useState(0), 2), scrollHeight = _e[0], setScrollHeight = _e[1];
    useEffect(function () { return setMounted(true); }, []);
    var handleToggle = useCallback(function (attribute) {
        window.scrollTo(0, 0);
        setActiveFacet(activeFacet === attribute ? undefined : attribute);
    }, [activeFacet]);
    var onShowFilters = function () {
        var scrollTop = window.pageYOffset;
        if (!isVisible) {
            setScrollHeight(scrollTop);
            window.scrollTo(0, 0);
        }
        else {
            window.scrollTo(0, scrollHeight);
        }
        setVisible(!isVisible);
    };
    var itemsToClear = useItemsToClear(items);
    var activeFilterCount = itemsToClear
        .filter(function (item, index, items) { return items.findIndex(function (_a) {
        var id = _a.id;
        return id === item.id;
    }) === index; })
        .reduce(function (prev, curr) {
        var itemCount = (curr.items && curr.items.length) || 1;
        return prev + itemCount;
    }, 0);
    return (React__default.createElement(Fragment, null,
        !isVisible && (React__default.createElement("div", { className: "facets-mobile-trigger" },
            React__default.createElement(Button, { className: "facets-mobile-trigger__button", caption: getLabel('search.filter') + "\n              " + (activeFilterCount > 0 ? "(" + activeFilterCount + ")" : ''), icon: "filter", onClick: onShowFilters }))),
        hasMounted && ReactDOM.createPortal(renderFacets(), document.body),
        isVisible && React__default.createElement(HideApp, null)));
    function renderFacets() {
        var facetsClass = classnames('facets-mobile', {
            'facets-mobile--hidden': !isVisible,
        });
        var facetHeaderClass = classnames('facets-mobile__header', {
            'facets-mobile__header--hidden': !!activeFacet,
        });
        var facetContainerClass = classnames('facets-mobile__container', {
            'facets-mobile__container--layered': !!activeFacet,
        });
        var footerButtonClass = classnames('facets-mobile__footer-button', {
            'facets-mobile__footer-button': !!activeFacet,
        });
        return (React__default.createElement("div", { className: facetsClass },
            React__default.createElement("div", { className: facetHeaderClass },
                React__default.createElement(Heading, { variant: "small", className: "facets-mobile__title" },
                    getLabel('products.filters'),
                    " ",
                    !!items.length && "(" + activeFilterCount + ")"),
                React__default.createElement(ClearFacetFilter, { label: getLabel('search.filters.clearAll'), onClear: function () { return refine(itemsToClear); }, isDisabled: !itemsToClear.length })),
            React__default.createElement("div", { className: facetContainerClass }, facets.map(renderFacet)),
            React__default.createElement("div", { className: "facets-mobile__footer" }, activeFacet ? (React__default.createElement(Button, { className: footerButtonClass, caption: getLabel('search.filters.save'), variant: "outline", onClick: function () { return handleToggle(undefined); } })) : (React__default.createElement(Button, { className: footerButtonClass, caption: activeFilterCount > 0
                    ? getLabel('search.filters.showResults') + " " + nbHits
                    : getLabel('search.filters.close'), variant: activeFilterCount > 0 ? 'solid' : 'outline', onClick: onShowFilters })))));
    }
    function renderFacet(facet) {
        switch (facet.id) {
            case FacetId.price:
                return (React__default.createElement(ConnectedFacetInputPriceRangeMobile$1, { key: facet.attribute, attribute: facet.attribute, title: getLabel(facet.labelKey || facet.id), isActive: activeFacet === facet.attribute, onToggle: handleToggle, expandedState: !!activeFacet }));
            default:
                return (React__default.createElement(ConnectedFacetContainerMobile$1, { facet: facet, searchable: facet.searchable, key: facet.attribute, attribute: facet.attribute, title: getLabel(facet.labelKey || facet.id), isActive: facet.attribute === activeFacet, expandedState: !!activeFacet, onToggle: handleToggle, limit: 100, showMoreLabel: getLabel('search.filters.showMore'), showLessLabel: getLabel('search.filters.showLess') }));
        }
    }
};
var FacetsMobile$1 = connectCurrentRefinements(connectStats(FacetsMobile));
var HideApp = function () {
    useEffect(function () {
        var container = document.getElementById('app-container');
        if (container) {
            container.style.display = 'none';
        }
        return function cleanUp() {
            if (container) {
                container.style.display = '';
            }
        };
    });
    return null;
};

var ClearRefinements = function (_a) {
    var items = _a.items, refine = _a.refine;
    var getLabel = useIntl().getLabel;
    var itemsToClear = useItemsToClear(items);
    var handleClick = React.useCallback(function () {
        refine(itemsToClear);
    }, [refine, itemsToClear]);
    if (!itemsToClear.length) {
        return null;
    }
    return (React.createElement(Button, { className: "clear-refinements", onClick: handleClick, caption: getLabel('search.filters.clearAll'), variant: "ghost", size: "custom" }));
};
var ClearRefinements$1 = connectCurrentRefinements(ClearRefinements);

var CurrentRefinements = function (_a) {
    var items = _a.items, refine = _a.refine;
    var facets = useAlgoliaConfig().facets;
    var intl = useIntl();
    var uniqItems = React.useMemo(function () { return uniqBy(items, function (item) { return item.attribute + item.label; }); }, [items]);
    var refinementItems = React.useMemo(function () {
        return uniqItems.reduce(function (result, item, i) {
            var facet = facets.find(function (_a) {
                var attribute = _a.attribute;
                return attribute === item.attribute;
            });
            if (!facet || facet.hidden) {
                return result;
            }
            var element = (React.createElement(React.Fragment, { key: i }, isRangeRefinement(item)
                ? renderRange(item)
                : item.items
                    ? renderItems(item.items, facet)
                    : null));
            return __spreadArray(__spreadArray([], __read(result)), [element]);
        }, []);
    }, [uniqItems]);
    return refinementItems.length > 0 ? (React.createElement("div", { className: "current-refinements" },
        refinementItems,
        React.createElement(ClearRefinements$1, null))) : null;
    function renderItems(items, facet) {
        return (React.createElement(React.Fragment, null, items.map(function (item) { return (React.createElement("span", { key: item.label, className: "current-refinements__tag" },
            React.createElement(Tag, { onClick: function () { return refine(item.value); } },
                facet.showLabel && facet.labelKey && intl.hasLabel(facet.labelKey) && (React.createElement("span", { className: "current-refinements__label" },
                    intl.getLabel(facet.labelKey || facet.id),
                    ":",
                    ' ')),
                getFacetOptionLabel(facet, item.label, intl).label))); })));
    }
    function renderRange(_a) {
        var _b = _a.currentRefinement, min = _b.min, max = _b.max, label = _a.label, value = _a.value;
        return (React.createElement("span", { key: label, className: "current-refinements__tag" },
            React.createElement(Tag, { onClick: function () { return refine(value); } },
                React.createElement(Price, { value: Math.round(min / 100), currency: intl.currency, centAmount: false }),
                ' – ',
                React.createElement(Price, { value: Math.round(max / 100), currency: intl.currency, centAmount: false }))));
    }
};
var CurrentRefinements$1 = connectCurrentRefinements(CurrentRefinements);
function isRangeRefinement(refinement) {
    var currentRefiment = refinement.currentRefinement;
    return currentRefiment.hasOwnProperty('min') || currentRefiment.hasOwnProperty('max');
}

function FacetHeader(_a) {
    var title = _a.title, onSearch = _a.onSearch, onClear = _a.onClear, enableClearButton = _a.enableClearButton;
    var intl = useIntl();
    return (React__default.createElement("div", { className: "facet-header" },
        React__default.createElement("div", { className: "facet-header__heading" },
            React__default.createElement("span", null, title),
            onClear && (React__default.createElement(ClearFacetFilter, { onClear: onClear, isDisabled: !enableClearButton, label: intl.getLabel('search.filters.clear', {
                    defaultValue: 'clear',
                }) }))),
        onSearch && (React__default.createElement(FacetSearchBox, { placeholder: intl.getLabel('search.filters.placeholder'), onSearch: function (event) { return onSearch(event.target.value); } }))));
}

var FacetContainer = function (_a) {
    var title = _a.title, onClear = _a.onClear, onSearch = _a.onSearch, children = _a.children, enableClearButton = _a.enableClearButton;
    return (React__default.createElement("div", { className: "facet-container" },
        React__default.createElement(FacetHeader, { title: title, enableClearButton: enableClearButton, onSearch: onSearch, onClear: onClear }),
        React__default.createElement("div", { className: "facet-container__inner" }, children)));
};

var FacetInputList = function (_a) {
    var items = _a.items, onRefine = _a.onRefine, facet = _a.facet;
    var sortedItems = orderFacetOptions({ facet: facet, items: items });
    return (React__default.createElement(AnimatePresence, null, sortedItems.map(function (item) { return (React__default.createElement(motion.div, { variants: facetInputItemVariants, key: item.label },
        React__default.createElement(RefinementItem, { key: item.label, item: item, facet: facet, onRefine: onRefine }))); })));
};
var facetInputItemVariants = {
    flip: {
        transition: {
            type: 'spring',
            stiffness: 500,
            damping: 800,
        },
    },
};

var ConnectedFacetInputList = connectRefinementList(ConnectedFacetInputList$1);
function ConnectedFacetInputList$1(_a) {
    var facet = _a.facet, attribute = _a.attribute, items = _a.items, refine = _a.refine, isActive = _a.isActive, onToggle = _a.onToggle, searchable = _a.searchable, searchForItems = _a.searchForItems, isFromSearch = _a.isFromSearch;
    var intl = useIntl();
    if (!items.length && !isFromSearch) {
        return null;
    }
    var refineCount = items.filter(function (x) { return x.isRefined; }).length;
    return (React__default.createElement("div", { className: "connected-facet-input-list" },
        React__default.createElement(ButtonWithDropdown, { title: intl.getLabel(facet.labelKey || facet.id), onClick: function () { return onToggle(attribute); }, isActive: isActive, label: intl.getLabel(facet.labelKey || facet.id), className: "connected-facet-input-list__button" },
            React__default.createElement(FacetContainer, { onSearch: searchable ? searchForItems : undefined, onClear: function () { return refine([]); }, enableClearButton: refineCount > 0, title: React__default.createElement(React__default.Fragment, null,
                    refineCount,
                    ' ',
                    intl.getLabel('search.filters.selected', {
                        defaultValue: 'selected',
                    })) },
                React__default.createElement(FacetInputList, { facet: facet, items: items, onRefine: refine })))));
}

var ConnectedFacetInputPriceRange = connectRange(ConnectedFacetInputPriceRange$1);
function ConnectedFacetInputPriceRange$1(_a) {
    var facet = _a.facet, attribute = _a.attribute, refine = _a.refine, isActive = _a.isActive, onToggle = _a.onToggle, min = _a.min, max = _a.max, currentRefinement = _a.currentRefinement;
    var clearHandler = useCallback(function () { return refine({ min: min, max: max }); }, [min, max]);
    var intl = useIntl();
    if (min === max) {
        return null;
    }
    return (React__default.createElement("div", { className: "connected-facet-input-range" },
        React__default.createElement(ButtonWithDropdown, { title: intl.getLabel(facet.labelKey || facet.id), onClick: function () { return onToggle(attribute); }, isActive: isActive, label: intl.getLabel(facet.labelKey || facet.id), className: "connected-facet-input-range__button" },
            React__default.createElement(FacetContainer, { onClear: clearHandler, enableClearButton: currentRefinement.min !== min || currentRefinement.max !== max, title: React__default.createElement(React__default.Fragment, null,
                    React__default.createElement(Price, { value: roundPrice(currentRefinement.min), currency: intl.currency, centAmount: false }),
                    ' – ',
                    React__default.createElement(Price, { value: roundPrice(currentRefinement.max), currency: intl.currency, centAmount: false })) },
                React__default.createElement(FacetInputPriceRange, { min: min, max: max, value: currentRefinement, onChange: refine, renderNumber: roundPrice })))));
}
function roundPrice(value) {
    return Math.round(value / 100);
}

var FacetsDesktop = function (_a) {
    var facets = _a.facets;
    var _b = __read(useState(), 2), activeFacet = _b[0], setActiveFacet = _b[1];
    var handleToggle = useCallback(function (attribute) { return setActiveFacet(activeFacet === attribute ? undefined : attribute); }, [activeFacet]);
    var ref = React__default.useRef(null);
    useOnClickOutside(ref, function () { return setActiveFacet(undefined); });
    return (React__default.createElement("div", { className: "facets-desktop" },
        React__default.createElement("div", { ref: ref, className: "facets-desktop__top-bar" }, facets.map(function (facet) { return (React__default.createElement(Fragment, { key: facet.attribute }, renderFacet(facet))); })),
        React__default.createElement("div", { className: "facets-desktop__refinements" },
            React__default.createElement(CurrentRefinements$1, null))));
    function renderFacet(facet) {
        switch (facet.id) {
            case FacetId.price:
                return (React__default.createElement(ConnectedFacetInputPriceRange, { key: facet.attribute, facet: facet, attribute: facet.attribute, isActive: facet.attribute === activeFacet, onToggle: handleToggle }));
            default:
                return (React__default.createElement(ConnectedFacetInputList, { key: facet.attribute, facet: facet, attribute: facet.attribute, isActive: facet.attribute === activeFacet, onToggle: handleToggle, searchable: facet.searchable, limit: 100 }));
        }
    }
};

var noOp = function () { return null; };
var VirtualSortBy = connectSortBy(noOp);
var VirtualRefinementList = connectRefinementList$1(noOp);
var VirtualRange = connectRange$1(noOp);
var VirtualSearchBox = connectSearchBox$1(noOp);
var VirtualInfinitePagination = function (_a) {
    var _b;
    var pageSize = _a.pageSize, searchState = _a.searchState;
    // On the server, set the offset so we start at the latest viewed page so only those results are fetched
    // E.G page=3 will result in offset=72 length=24
    var offset = ((_b = searchState.configure) === null || _b === void 0 ? void 0 : _b.offset) || 0;
    return React__default.createElement(Configure$1, { offset: offset, length: pageSize });
};
/**
 * VirtualFacets should never render HTML
 */
var VirtualFacets = function () {
    var _a = useAlgoliaConfig(), facets = _a.facets, sortIndices = _a.sortIndices, filters = _a.filters, pageSize = _a.pageSize, ruleContexts = _a.ruleContexts, searchState = _a.algoliaInstantSearchProps.searchState, facetingAfterDistinct = _a.facetingAfterDistinct;
    return (React__default.createElement(Fragment, null,
        React__default.createElement(Configure$1, { clickAnalytics: true, facetingAfterDistinct: facetingAfterDistinct }),
        sortIndices.length > 0 && (React__default.createElement(VirtualSortBy, { defaultRefinement: sortIndices[0].value, items: sortIndices })),
        React__default.createElement(VirtualInfinitePagination, { pageSize: pageSize, searchState: searchState }),
        React__default.createElement(VirtualSearchBox, null),
        facets.map(function (facet) {
            switch (facet.id) {
                case FacetId.price:
                    return React__default.createElement(VirtualRange, { key: facet.attribute, attribute: facet.attribute });
                default:
                    return (React__default.createElement(VirtualRefinementList, { key: facet.attribute, attribute: facet.attribute, defaultRefinement: facet.value, limit: 100 }));
            }
        }),
        React__default.createElement(Configure$1, { filters: filters, ruleContexts: ruleContexts })));
};

var SortBy = function (_a) {
    var items = _a.items, refine = _a.refine, currentRefinement = _a.currentRefinement;
    var selected = items.find(function (item) { return item.value === currentRefinement; });
    var intl = useIntl();
    return (React.createElement("div", { className: "search-sort" },
        React.createElement("select", { className: "search-sort__select", value: currentRefinement, onChange: function (evt) { return refine(evt.target.value); } }, items.map(function (item) { return (React.createElement("option", { key: item.value, value: item.value, "aria-selected": true }, getLabel(item))); })),
        React.createElement("div", { className: "search-sort__content" },
            React.createElement("span", { className: "search-sort__sort-by" }, selected && getLabel(selected)),
            React.createElement("span", { className: "search-sort__icon" },
                React.createElement(Icon, { name: "chevron-down" })))));
    function getLabel(item) {
        var label = item.label ? item.label : item.labelKey ? intl.getLabel(item.labelKey) : '';
        if (!label) {
            console.error('A sort-item is missing both label as labelKey');
        }
        return label;
    }
};
var SortBy$1 = connectSortBy(SortBy);

var PRICE_FROM_PARAM = FacetId.price + 'From';
var PRICE_TO_PARAM = FacetId.price + 'To';
var QUERY_KEYS = ['q', 'page', 'sortBy', PRICE_FROM_PARAM, PRICE_TO_PARAM];
function getQueryParamsFromUri(uri) {
    if (uri === void 0) { uri = ''; }
    return decode(uri.split('?')[1] || '');
}
function getQueryKey(key, facets) {
    var keys = QUERY_KEYS.concat(facets.map(function (f) { return f.id; }));
    var lookup = keys.reduce(function (result, key) {
        result[key.toLowerCase()] = key;
        return result;
    }, {});
    return lookup[key.toLowerCase()];
}
function getNonQueryObject(uri, _a) {
    var facets = _a.facets;
    return Object.entries(getQueryParamsFromUri(uri)).reduce(function (result, _a) {
        var _b = __read(_a, 2), key = _b[0], value = _b[1];
        if (!getQueryKey(key, facets)) {
            result[key] = value;
        }
        return result;
    }, {});
}
function queryStringToQueryObject(uri, _a) {
    var facets = _a.facets;
    return Object.entries(getQueryParamsFromUri(uri)).reduce(function (result, _a) {
        var _b = __read(_a, 2), key = _b[0], value = _b[1];
        var translatedKey = getQueryKey(key, facets);
        if (translatedKey) {
            result[translatedKey] = value;
        }
        return result;
    }, {});
}
function queryStringToSearchState(uri, qsOptions) {
    return queryObjectToSearchState(queryStringToQueryObject(uri, qsOptions), qsOptions);
}
function searchStateToQueryObject(searchState, _a) {
    var facets = _a.facets, pageSize = _a.pageSize, sortIndices = _a.sortIndices, presetQueryObject = _a.presetQueryObject;
    var facetsVisible = facets.filter(isFacetVisible);
    return flowRight(addPage, addSort, addQuery, addPriceRange, addRefinementListAttributes)({});
    function addPage(queryObject) {
        var _a;
        var _b = searchState.configure || {
            length: pageSize,
            page: 1,
            offset: 0,
        }, length = _b.length, page = _b.page, offset = _b.offset;
        var newPageIndex = page;
        if (length - offset === pageSize) {
            //Server.
            newPageIndex = offset === 0 ? page + 1 : page;
        }
        if (offset === 0 && length > pageSize) {
            // Client. We're not on page one so we calculate the page
            newPageIndex = Math.ceil(length / pageSize);
        }
        if (offset === 0 && length === pageSize && ((_a = searchState.configure) === null || _a === void 0 ? void 0 : _a.filters)) {
            // If a filter is enabled we set the page back to one
            searchState.configure.page = 1;
            newPageIndex = 1;
        }
        if (newPageIndex > 1) {
            queryObject.page = newPageIndex.toString();
        }
        return queryObject;
    }
    function addSort(queryObject) {
        var sortBy = searchState.sortBy;
        var sortIndex = sortIndices.find(function (x) { return x.value === sortBy; });
        var isDefaultSortIndex = presetQueryObject.sortBy
            ? sortIndex && sortIndex.id === presetQueryObject.sortBy
            : sortIndex && sortIndex.id === sortIndices[0].id;
        if (sortIndex && sortIndex.id && !isDefaultSortIndex) {
            queryObject.sortBy = sortIndex.id;
        }
        return queryObject;
    }
    function addQuery(queryObject) {
        if (!presetQueryObject.q && searchState.query) {
            queryObject.q = searchState.query;
        }
        return queryObject;
    }
    function addPriceRange(queryObject) {
        var facet = facetsVisible.find(function (f) { return f.id === FacetId.price; });
        var value = facet && searchState.range && searchState.range[facet.attribute];
        if (facet && value && (value.min || value.max)) {
            value.min && (queryObject[PRICE_FROM_PARAM] = Math.round(value.min / 100).toString());
            value.max && (queryObject[PRICE_TO_PARAM] = Math.round(value.max / 100).toString());
        }
        return queryObject;
    }
    function addRefinementListAttributes(queryObject) {
        Object.entries(searchState.refinementList || {}).forEach(function (_a) {
            var _b = __read(_a, 2), attribute = _b[0], value = _b[1];
            var facet = facetsVisible.find(function (f) { return f.attribute === attribute; });
            if (facet && value.length) {
                queryObject[facet.id] = value;
            }
        }, {});
        return queryObject;
    }
}
function queryObjectToSearchState(queryObject, _a) {
    var facets = _a.facets, pageSize = _a.pageSize, sortIndices = _a.sortIndices, isCreatingPresetState = _a.isCreatingPresetState, presetQueryObject = _a.presetQueryObject;
    var facetsVisible = isCreatingPresetState ? facets : facets.filter(isFacetVisible);
    return flowRight(isCreatingPresetState ? skip : addPage, addSort, addQuery, addPriceRange, addRefinementListAttributes)({
        configure: { aroundLatLng: false },
        refinementList: {},
        range: {},
    });
    function addPage(searchState) {
        var _a;
        if (queryObject.page && ((_a = searchState.configure) === null || _a === void 0 ? void 0 : _a.offset) !== 0) {
            var page = Math.max(1, parseInt(queryObject.page, 10));
            searchState.configure.page = page;
            searchState.configure.offset = Math.min((page - 1) * pageSize, 999);
            searchState.configure.length = Math.min(page * pageSize, 999);
        }
        return searchState;
    }
    function addSort(searchState) {
        var sortBy = queryObject.sortBy;
        var _a = (sortIndices.find(function (x) { return x.id === sortBy; }) || {}).value, value = _a === void 0 ? null : _a;
        if (value) {
            searchState.sortBy = value;
        }
        return searchState;
    }
    function addQuery(searchState) {
        var query = presetQueryObject.q || queryObject.q;
        if (query) {
            searchState.query = query;
        }
        return searchState;
    }
    function addPriceRange(searchState) {
        var facet = facetsVisible.find(function (f) { return f.id === FacetId.price; });
        var priceKeys = [
            queryObject[PRICE_FROM_PARAM],
            queryObject[PRICE_TO_PARAM],
        ];
        var _a = __read(priceKeys.map(function (x) { return (parseFloat(x || '') || 0) * 100; }), 2), min = _a[0], max = _a[1];
        if (facet && (min || max)) {
            searchState.range[facet.attribute] = {};
            min && (searchState.range[facet.attribute].min = min);
            max && (searchState.range[facet.attribute].max = max);
        }
        return searchState;
    }
    function addRefinementListAttributes(searchState) {
        Object.entries(queryObject).forEach(function (_a) {
            var _b = __read(_a, 2), id = _b[0], values = _b[1];
            values = [].concat(values);
            var facet = values.length && facetsVisible.find(function (f) { return f.id === id; });
            if (facet) {
                searchState.refinementList[facet.attribute] = values;
            }
        });
        return searchState;
    }
}
var skip = function (x) { return x; };

var useQueryChange = function (NextRouter, searchState, clientQueryString) {
    var _a = useAlgoliaConfig(), facets = _a.facets, sortIndices = _a.sortIndices, pageSize = _a.pageSize, presetQueryObject = _a.presetQueryObject;
    var _b = useMemo(function () { return ({
        queryObject: searchStateToQueryObject(searchState, {
            facets: facets,
            sortIndices: sortIndices,
            pageSize: pageSize,
            presetQueryObject: presetQueryObject,
        }),
        nonQueryObject: getNonQueryObject(clientQueryString, { facets: facets }),
    }); }, [searchState, JSON.stringify(facets), sortIndices, pageSize]), queryObject = _b.queryObject, nonQueryObject = _b.nonQueryObject;
    var query = useMemo(function () { return (__assign(__assign({}, queryObject), nonQueryObject)); }, [
        JSON.stringify(queryObject),
        JSON.stringify(nonQueryObject),
    ]);
    useDebouncedEffect(function () {
        var _a = __read((NextRouter.asPath || '').split('#'), 2), pathWithoutHash = _a[0], hash = _a[1];
        var pathname = pathWithoutHash.split('?')[0];
        NextRouter.replace({ pathname: NextRouter.pathname, query: query }, { pathname: pathname, query: query, hash: hash }, { shallow: true });
    }, 500, [query]);
};
function UseQueryChange(_a) {
    var NextRouter = _a.NextRouter, searchState = _a.searchState, clientQueryString = _a.clientQueryString;
    useQueryChange(NextRouter, searchState, clientQueryString);
    return null;
}

function AlgoliaConfigProvider(props) {
    var isEnabled = props.isEnabled, resultsState = props.resultsState, clientQueryString = props.clientQueryString, presetQueryString = props.presetQueryString, NextRouter = props.NextRouter, ruleContexts = props.ruleContexts, locale = props.locale, facetingAfterDistinct = props.facetingAfterDistinct;
    var _a = props.options, apiKey = _a.apiKey, appId = _a.appId, filters = _a.filters, indexName = _a.indexName, _b = _a.pageSize, pageSize = _b === void 0 ? 24 : _b;
    var searchClient = useMemo(function () { return algoliaSearch(appId, apiKey); }, [appId, apiKey]);
    var _c = useMemo(function () {
        var facets = configureFacets(props.options.facets, locale, presetQueryString);
        var sortIndices = props.options.sortIndices.filter(function (_a) {
            var value = _a.value;
            return value;
        });
        var qsOptions = {
            facets: facets,
            pageSize: pageSize,
            sortIndices: sortIndices,
            presetQueryObject: {},
        };
        var presetQueryObject = queryStringToQueryObject(presetQueryString, qsOptions);
        var presetQueryState = queryObjectToSearchState(presetQueryObject, __assign(__assign({}, qsOptions), { isCreatingPresetState: true, presetQueryObject: presetQueryObject }));
        var clientQueryState = queryStringToSearchState(clientQueryString, __assign(__assign({}, qsOptions), { presetQueryObject: presetQueryObject }));
        var initialSearchState = merge(presetQueryState, clientQueryState);
        return { facets: facets, sortIndices: sortIndices, presetQueryObject: presetQueryObject, initialSearchState: initialSearchState };
    }, [
        props.options.facets,
        props.options.sortIndices,
        locale,
        presetQueryString,
        pageSize,
        clientQueryString,
    ]), facets = _c.facets, sortIndices = _c.sortIndices, presetQueryObject = _c.presetQueryObject, initialSearchState = _c.initialSearchState;
    var _d = __read(useState(initialSearchState), 2), searchState = _d[0], onSearchStateChange = _d[1];
    var value = useMemo(function () { return ({
        isEnabled: isEnabled,
        pageSize: pageSize,
        filters: filters,
        facets: facets,
        facetingAfterDistinct: facetingAfterDistinct,
        sortIndices: sortIndices,
        presetQueryObject: presetQueryObject,
        ruleContexts: ruleContexts,
        algoliaInstantSearchProps: {
            onSearchStateChange: onSearchStateChange,
            indexName: indexName,
            resultsState: resultsState,
            searchState: searchState,
            searchClient: searchClient,
        },
    }); }, [
        isEnabled,
        pageSize,
        filters,
        facets,
        facetingAfterDistinct,
        sortIndices,
        presetQueryObject,
        ruleContexts,
        indexName,
        resultsState,
        searchState,
        searchClient,
    ]);
    return (React__default.createElement(AlgoliaConfig.Provider, { value: value },
        isEnabled && NextRouter && (React__default.createElement(UseQueryChange, { NextRouter: NextRouter, searchState: searchState, clientQueryString: clientQueryString })),
        props.children));
}
function configureFacets(facets, locale, presetQueryString) {
    var presetKeyVal = Object.entries(queryStringToQueryObject(presetQueryString || '', { facets: facets })).reduce(function (result, _a) {
        var _b = __read(_a, 2), key = _b[0], value = _b[1];
        result[key.toLowerCase()] = value;
        return result;
    }, {});
    return facets.map(function (facet) {
        var rawValue = presetKeyVal[facet.id.toLowerCase()];
        var value = Array.isArray(rawValue) ? rawValue : rawValue ? [rawValue] : [];
        var hidden = facet.hidden || !!value.length;
        if (facet.id === FacetId.price) {
            var hasPriceFrom = presetKeyVal.hasOwnProperty(PRICE_FROM_PARAM.toLowerCase());
            var hasPriceTo = presetKeyVal.hasOwnProperty(PRICE_TO_PARAM.toLowerCase());
            hidden = hidden || hasPriceFrom || hasPriceTo;
        }
        return __assign(__assign({}, facet), { options: facet.options && lowercaseKeys(facet.options), value: value.length ? value : undefined, attribute: facet.isLocalized ? facet.attribute + "_" + locale : facet.attribute, hidden: hidden });
    });
}
function lowercaseKeys(obj) {
    return Object.keys(obj).reduce(function (result, key) {
        result[key.toLowerCase()] = obj[key];
        return result;
    }, {});
}

function AlgoliaSearch(_a) {
    var children = _a.children;
    var _b = useAlgoliaConfig(), algoliaInstantSearchProps = _b.algoliaInstantSearchProps, isEnabled = _b.isEnabled, facetingAfterDistinct = _b.facetingAfterDistinct;
    return (React__default.createElement(InstantSearch, __assign({}, algoliaInstantSearchProps),
        React__default.createElement(VirtualFacets, null),
        React__default.createElement(Configure$1, { clickAnalytics: true, facetingAfterDistinct: facetingAfterDistinct }),
        React__default.createElement(WithStateResults, { isEnabled: isEnabled }, children)));
}
var WithStateResults = connectStateResults$1(function (_a) {
    var children = _a.children, isEnabled = _a.isEnabled, stateResults = __rest(_a, ["children", "isEnabled"]);
    return children(isEnabled ? stateResults : null);
});
function fetchAlgoliaConfig(props) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, appId, apiKey, searchClient, _b, err_1;
        var _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    if (!props.isEnabled) {
                        return [2 /*return*/, props];
                    }
                    _a = props.options, appId = _a.appId, apiKey = _a.apiKey;
                    searchClient = algoliaSearch(appId, apiKey);
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 3, , 4]);
                    _b = [__assign({}, props)];
                    _c = {};
                    return [4 /*yield*/, findResultsState(function (providedProps) {
                            return (React__default.createElement(AlgoliaConfigProvider, __assign({}, props),
                                React__default.createElement(InstantSearchContainer, __assign({}, providedProps),
                                    React__default.createElement(VirtualFacets, null))));
                        }, __assign({ searchClient: searchClient }, props.options))];
                case 2: return [2 /*return*/, __assign.apply(void 0, _b.concat([(_c.resultsState = _d.sent(), _c)]))];
                case 3:
                    err_1 = _d.sent();
                    console.log('An error occured while fetching algolia hits');
                    console.error(err_1);
                    return [2 /*return*/, __assign(__assign({}, props), { isEnabled: false })];
                case 4: return [2 /*return*/];
            }
        });
    });
}
var InstantSearchContainer = function (props) {
    var algoliaInstantSearchProps = useAlgoliaConfig().algoliaInstantSearchProps;
    return (React__default.createElement(InstantSearch, __assign({}, algoliaInstantSearchProps, props), props.children));
};

var ALGOLIA_INSIGHTS_VERSION = packageInfo.version;
var AlgoliaAnalytics = function (_a) {
    var appId = _a.appId, apiKey = _a.apiKey;
    if (!apiKey || !appId || !ALGOLIA_INSIGHTS_VERSION) {
        console.warn('Unable to initialize Algolia Insights! Check the appId, apiKey and the search-insights package version.');
        return null;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("link", { rel: "preconnect", href: "https://cdn.jsdelivr.net/" }),
        React.createElement("script", { dangerouslySetInnerHTML: {
                __html: "var ALGOLIA_INSIGHTS_SRC = \"https://cdn.jsdelivr.net/npm/search-insights@" + ALGOLIA_INSIGHTS_VERSION + "\";\n  !function(e,a,t,n,s,i,c){e.AlgoliaAnalyticsObject=s,e[s]=e[s]||function(){\n  (e[s].queue=e[s].queue||[]).push(arguments)},i=a.createElement(t),c=a.getElementsByTagName(t)[0],\n  i.async=1,i.src=n,c.parentNode.insertBefore(i,c)\n  }(window,document,\"script\",ALGOLIA_INSIGHTS_SRC,\"aa\");\n  // Initialize library\n  // TODO: move this to AlgoliaConfig\n  aa('init', {\n    appId: \"" + appId + "\",\n    apiKey: \"" + apiKey + "\"\n  });",
            } })));
};

function queryAlgolia(algoliaConfig, searchOptions) {
    return __awaiter(this, void 0, void 0, function () {
        var apiKey, appId, indexName, client, index, result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    apiKey = algoliaConfig.apiKey, appId = algoliaConfig.appId, indexName = algoliaConfig.indexName;
                    if (!apiKey || !appId || !indexName) {
                        console.error("[queryAlgolia]: missing ApiKey: " + apiKey + ", AppId:  " + appId + " or indexName : " + indexName + " ");
                        return [2 /*return*/, null];
                    }
                    client = algoliaSearch$1(appId, apiKey);
                    index = client.initIndex(indexName);
                    if (!index) {
                        console.error("[queryAlgolia]: Cannot search on uninstantiated index.");
                        return [2 /*return*/, null];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, index.search(searchOptions.query || '', __assign({}, searchOptions))];
                case 2:
                    result = _a.sent();
                    return [2 /*return*/, result];
                case 3:
                    _a.sent();
                    console.error("[queryAlgolia]: Something went wrong searching Algolia.");
                    return [2 /*return*/, null];
                case 4: return [2 /*return*/];
            }
        });
    });
}

function useAlgoliaSearch(algoliaConfig, searchOptions) {
    var isSubscribed = React.useRef(true);
    var _a = __read(React.useState({
        result: [],
        hasError: false,
        isLoading: false,
    }), 2), state = _a[0], setState = _a[1];
    React.useEffect(function () {
        !state.isLoading && search();
        function search() {
            return __awaiter(this, void 0, void 0, function () {
                var result;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            setState(function (state) { return (__assign(__assign({}, state), { isLoading: true })); });
                            return [4 /*yield*/, queryAlgolia(algoliaConfig, searchOptions)];
                        case 1:
                            result = _a.sent();
                            if (result === null) {
                                console.error("[useAlgoliaSearch]: Something went wrong searching Algolia.");
                                isSubscribed.current &&
                                    setState(function (state) { return (__assign(__assign({}, state), { hasError: true, isLoading: false })); });
                                return [2 /*return*/];
                            }
                            isSubscribed.current &&
                                setState(function (state) { return (__assign(__assign({}, state), { result: result.hits, isLoading: false })); });
                            return [2 /*return*/];
                    }
                });
            });
        }
        return function () {
            isSubscribed.current = false;
        };
    }, [searchOptions, algoliaConfig]);
    return state;
}

var AlgoliaFilterOperator;
(function (AlgoliaFilterOperator) {
    AlgoliaFilterOperator["OR"] = "OR";
    AlgoliaFilterOperator["NOT"] = "NOT";
    AlgoliaFilterOperator["AND"] = "AND";
    AlgoliaFilterOperator["AND_NOT"] = "AND NOT";
})(AlgoliaFilterOperator || (AlgoliaFilterOperator = {}));
/**
 * Helper to return a filter based on id and value.
 * If the facet-value contains spaces, we should enclose it in quotes
 */
var getFilter = function (id, value) {
    var escapedValue = typeof value === 'string' && value.includes(' ') ? "'" + value + "'" : value;
    return id + ":" + escapedValue;
};
function createAlgoliaFilters(filterableAttributes, operator, prefix) {
    if (!filterableAttributes.length) {
        return operator || prefix ? '' : [];
    }
    /**
     * Iterate over the filterableAttributes
     * Based on the type of value create a filter string
     */
    var filters = filterableAttributes.reduce(function (prev, _a) {
        var id = _a.id, value = _a.value;
        /**
         * If the value is a simple string, return the value:
         * `<filterName>:<filterValue>`
         */
        if (typeof value === 'string') {
            var result = getFilter(id, value);
            prev.push(result);
        }
        /**
         * If the value is an array, create a string with the OR operator between values encapsulated by `()`
         *  `(<filterName>:<filterValue1> OR <filterName>:<filterValue2> OR <filterName>:<filterValue2>)`
         */
        if (Array.isArray(value)) {
            var result = value.map(function (val) { return getFilter(id, val); }).join(" " + AlgoliaFilterOperator.OR + " ");
            var filterString = value.length > 1 ? "(" + result + ")" : result;
            prev.push(filterString);
        }
        return prev;
    }, []);
    /**
     * If an operator or prefix is defined, adjust the string:
     * `<Prefix> <filterName1>:<filterValue> <Operator> <filterName2>:<filterValue>`
     */
    if (operator || prefix) {
        return "" + (prefix ? prefix + " " : '') + filters.join(" " + operator + " ");
    }
    else {
        return filters;
    }
}

/**
 * Creates a filter string for a given array of sku's.
 */
function createFiltersFromSkus(skus) {
    if (skus.length === 0) {
        return '';
    }
    var filterableSkus = skus.filter(Boolean).map(function (sku) { return ({
        id: 'masterVariant.sku',
        value: sku,
    }); });
    return createAlgoliaFilters(filterableSkus, AlgoliaFilterOperator.OR);
}
/**
 * Returns a filter string based on the query string
 * The queryParameters are extracted and stored in an object containing the parameter and the value(s)
 * This object is matched to the given facets so only the existing facets are used.
 */
function createFiltersFromQuery(query, facets) {
    if (!query || !facets) {
        return '';
    }
    /**
     * Convert the querystring to an object of attributes,
     * These attributes are checked against the configured facets
     * Only existing attributes are returned.
     */
    var queryObject = queryStringToQueryObject(query, { facets: facets });
    /**
     * Iterate over the keys and for each entry create a FilterableAttribute
     */
    var filterableAttributes = Object.keys(queryObject)
        .map(function (filterKey) {
        // Find the facet belonging to the filter
        var attribute = facets === null || facets === void 0 ? void 0 : facets.find(function (facet) { return facet.id === filterKey; });
        var value = queryObject[filterKey];
        if (!attribute || !attribute.attribute) {
            return null;
        }
        return {
            id: attribute.attribute,
            value: value,
        };
    })
        // Filter only valid FilterableAttributes
        .filter(function (val) { return val !== null && Boolean(val.id); });
    return createAlgoliaFilters(filterableAttributes, AlgoliaFilterOperator.AND);
}

/**
 * QueryAlgoliaProducts is a component that mainly wraps the `useAlgoliaSearch` hook.
 * Based on the supplied the props `skus`, `queryString` and `ruleContext`  we map the data for querying Algolia.
 * This component expects a render function as a child which takes the searchResults as an argument.
 */
function QueryAlgoliaProducts(_a) {
    var skus = _a.skus, queryString = _a.queryString, ruleContext = _a.ruleContext, algoliaConfig = _a.algoliaConfig, children = _a.children;
    /**
     * Prepare options for searching
     * Creates the filters based on the given sku's or the queryString
     * The skus gets priority over the queryString when both are defined.
     */
    var searchOptions = React__default.useMemo(function () {
        var ruleContexts = typeof ruleContext === 'string' ? [ruleContext] : ruleContext;
        var filters = skus.length > 0
            ? createFiltersFromSkus(skus)
            : createFiltersFromQuery(queryString, algoliaConfig.facets);
        return {
            filters: filters,
            ruleContexts: ruleContexts,
        };
    }, [skus, ruleContext, queryString, algoliaConfig]);
    var result = useAlgoliaSearch(algoliaConfig, searchOptions);
    return React__default.createElement(React__default.Fragment, null, children(result));
}

var SearchPageDescription = function (_a) {
    var description = _a.description;
    var getLabel = useIntl().getLabel;
    var isMobile = MediaQuery.useIsBelow(MediaQuery.BreakpointName.TABLET_LANDSCAPE);
    var initialHeight = isMobile ? 64 : 72;
    return (React.createElement(Expandable, { id: "searchpage-description", className: "searchpage-description", showLessLabel: "- " + getLabel('search.filters.showLess'), showMoreLabel: "+ " + getLabel('search.filters.showMore'), initialHeight: initialHeight },
        React.createElement(RichTextArea, { content: description, className: "searchpage-description__body" })));
};

var SearchPageHeader = function (_a) {
    var pageTitle = _a.pageTitle, hitTitle = _a.hitTitle, description = _a.description;
    var getLabel = useIntl().getLabel;
    var _b = useAlgoliaConfig(), facets = _b.facets, algoliaInstantSearchProps = _b.algoliaInstantSearchProps, sortIndices = _b.sortIndices, facetingAfterDistinct = _b.facetingAfterDistinct;
    var isMobile = MediaQuery.useBreakpoint() === MediaQuery.BreakpointName.PHONE;
    var hasProductType = hasProductTypeFacet(algoliaInstantSearchProps.searchState, facets);
    var facetsVisible = facets.filter(function (facet) { return isFacetVisible(facet) && (hasProductType || PrimaryFacets[facet.id]); });
    /**
     * In this component we're mounting a new InstantSearch component to prevent resetting
     * refinements when refinementLists unmount. We basically implemented this solution:
     * https://www.algolia.com/doc/guides/building-search-ui/going-further/native/react/?language=react#create-a-modal
     */
    return (React.createElement(React.Fragment, null,
        React.createElement(InstantSearch, __assign({ key: isMobile ? 'facets-mobile' : 'facets-desktop' }, algoliaInstantSearchProps),
            React.createElement(VirtualFacets, null),
            React.createElement(Configure$1, { clickAnalytics: true, facetingAfterDistinct: facetingAfterDistinct }),
            React.createElement("div", { className: "search-page-header" },
                React.createElement(Container, { className: "search-page-header__container" },
                    React.createElement("div", { className: "search-page-header__intro" },
                        pageTitle && (React.createElement(Heading, { variant: "medium", component: "h1", className: "search-page-header__title" }, pageTitle)),
                        description && React.createElement(SearchPageDescription, { description: description })),
                    isMobile && React.createElement(FacetsMobile$1, { facets: facetsVisible }),
                    (hitTitle || sortIndices) && (React.createElement("div", { className: "search-page-header__sort-results" },
                        hitTitle && React.createElement("div", { className: "search-page-header__amount-hits" }, hitTitle),
                        sortIndices && sortIndices.length > 0 && (React.createElement("div", { className: "search-page-header__sort-by" },
                            React.createElement("span", { className: "search-page-header__sort-by-label" }, getLabel('search.results.sort.sortBy')),
                            React.createElement(SortBy$1, { defaultRefinement: sortIndices[0].value, items: sortIndices })))))),
                !isMobile && React.createElement(FacetsDesktop, { facets: facetsVisible })))));
};
function hasProductTypeFacet(searchState, facets) {
    var productTypeFacet = facets.find(function (facet) { return facet.id === FacetId.productType; });
    var val = productTypeFacet &&
        searchState.refinementList &&
        searchState.refinementList[productTypeFacet.attribute];
    return (val || []).length > 0;
}

function getForwardedQueryParamsFromFacets(facets, currentRefinements) {
    var params = facets.reduce(function (result, facet) {
        var _a;
        if (!currentRefinements || Object.keys(currentRefinements).length === 0) {
            return result;
        }
        if (facet.forwardAsQueryParam &&
            facet.attribute in currentRefinements &&
            Boolean(currentRefinements[facet.attribute])) {
            return __assign(__assign({}, result), (_a = {}, _a[facet.id] = currentRefinements[facet.attribute].join(','), _a));
        }
        return result;
    }, {});
    if (Object.keys(params).length === 0) {
        return undefined;
    }
    return params;
}

function useInfinitePageLength(searchState, pageSize) {
    var _a;
    var previousSearchStateRef = React.useRef(searchState);
    var lengthFromState = parseInt((_a = searchState.configure) === null || _a === void 0 ? void 0 : _a.length, 10);
    var _b = __read(React.useState(lengthFromState || pageSize), 2), length = _b[0], setLength = _b[1];
    var setLengthCallback = React.useCallback(function () {
        setLength(length + pageSize);
    }, [length, pageSize]);
    React.useEffect(function () {
        var _a = previousSearchStateRef.current, refinementList = _a.refinementList, range = _a.range;
        if (length !== pageSize &&
            (!isEqual(refinementList, searchState.refinementList) || !isEqual(range, searchState.range))) {
            // reset page size when a refinements are mutated
            setLength(pageSize);
            if (searchState.configure) {
                searchState.configure.offset = 0;
                searchState.configure.length = pageSize;
                searchState.configure.page = 1;
            }
        }
        previousSearchStateRef.current = searchState;
    }, [JSON.stringify(searchState), length, pageSize]);
    return [length, setLengthCallback];
}

var ConnectedInfinitePagination = function (_a) {
    var _b;
    var searchResults = _a.searchResults, searchState = _a.searchState, searching = _a.searching;
    var getLabel = useIntl().getLabel;
    var _c = useAlgoliaConfig().pageSize, pageSize = _c === void 0 ? 24 : _c;
    var _d = __read(useInfinitePageLength(searchState, pageSize), 2), length = _d[0], setLength = _d[1];
    return (React.createElement(React.Fragment, null,
        React.createElement(Configure$1, { offset: 0, length: length }),
        React.createElement(InfinitePagination, { onClick: setLength, buttonLabel: getLabel('search.loadMore'), labelKey: "search.pagingStatus", loaded: length, isLoading: searching, total: searchResults.nbHits, pageNr: (_b = searchState.configure) === null || _b === void 0 ? void 0 : _b.page })));
};
var ConnectedInfinitePagination$1 = connectStateResults(ConnectedInfinitePagination);

function createPagedHits(hits, total, size, fill) {
    if (fill === void 0) { fill = 0; }
    var max = Math.ceil(hits.length / size);
    var pages = Array.from({ length: fill }, function () { return null; });
    for (var i = 0; i < max; i++) {
        var start = i * size;
        var end = (i + 1) * size;
        var page = hits.slice(start, end);
        pages.push(page);
    }
    return {
        total: total,
        size: size,
        pages: pages,
    };
}

function ConnectedProductListing(_a) {
    var staticsUrl = _a.staticsUrl, formatProductUrl = _a.formatProductUrl, searchResults = _a.searchResults, searchState = _a.searchState, promotionBig = _a.promotionBig, promotionSmall = _a.promotionSmall, reimbursableLogos = _a.reimbursableLogos;
    var _b = useIntl(), getLabel = _b.getLabel, locale = _b.locale;
    var _c = useAlgoliaConfig(), pageSize = _c.pageSize, facets = _c.facets;
    var hits = searchResults.hits, total = searchResults.nbHits;
    var query = searchState.query, configure = searchState.configure, refinementList = searchState.refinementList;
    var page = (configure === null || configure === void 0 ? void 0 : configure.page) || 1;
    /**
     * Facets can be configured to be forwarded on PDP urls when they are active
     * for prefilling information on the PDP
     */
    var forwardedQueryParams = getForwardedQueryParamsFromFacets(facets, refinementList);
    /**
     * Creates a paged object of the hits we got from algolia.
     * If the amount of hits is lower than the amount of items we should render according to
     * the page number provided trough the URL, it means we should fill the page with the amount
     * of pages that can't be rendered yet, because the server-sided, only the last page is fetched
     */
    var pages = React__default.useMemo(function () {
        var fill = page * pageSize > hits.length && hits.length !== total ? page - 1 : 0;
        return createPagedHits(hits, total, pageSize, fill);
    }, [hits, total, pageSize, page]);
    if (hits.length === 0) {
        return (React__default.createElement(NoResults, { title: getLabel('search.noResults.title'), description: getLabel('search.noResults.text'), query: query }));
    }
    return (React__default.createElement(Fragment, null,
        React__default.createElement(ProductListing, { products: pages, formatProductUrl: formatProductUrl, staticsUrl: staticsUrl, showMoreButton: React__default.createElement(ConnectedInfinitePagination$1, null), promotionBig: promotionBig, promotionSmall: promotionSmall, reimbursableLogos: reimbursableLogos, forwardedQueryParams: forwardedQueryParams }),
        React__default.createElement(ProductsSd
        // TODO: SD components don't accept the light product model currently
        , { 
            // TODO: SD components don't accept the light product model currently
            items: hits, formatProductUrl: formatProductUrl, staticsUrl: staticsUrl, locale: locale })));
}
var ConnectedProductListing$1 = connectStateResults(ConnectedProductListing);

var getLocalizedAttributes = function (attributes, locale) {
    if (!attributes || !LocaleUtils.isValidLocale(locale)) {
        console.error("getLocalizedAttributes missing attributes or invalid locale: " + locale);
        return [];
    }
    return attributes.map(function (attr) {
        if (Array.isArray(attr.value)) {
            return __assign(__assign({}, attr), { value: attr.value.map(function (val) { return getLocalizedValue(val, locale); }) });
        }
        if (isPlainObject(attr.value)) {
            return __assign(__assign({}, attr), { value: getLocalizedValue(attr.value, locale) });
        }
        return attr;
    });
};

/**
 * getProductAttributesByFacets
 * Find the product attributes that are configured as a facet
 */
var getProductAttributesByFacets = function (facets, attributes, locale) {
    if (!facets || facets.length === 0 || !attributes || attributes.length === 0 || !locale) {
        console.error("Something went wrong trying to match product attributes to facets");
        return [];
    }
    var facetsToFilter = facets
        .filter(function (facet) { return facet.attribute.startsWith('filterableAttributes'); })
        .map(function (facet) {
        var attribute = facet.isLocalized ? facet.attribute + "_" + locale : facet.attribute;
        return { attribute: attribute, id: facet.id, type: facet.type || 'optional' };
    });
    return attributes.reduce(function (prev, attribute) {
        var facet = facetsToFilter.find(function (facet) { return facet.id === attribute.name; });
        if (facet) {
            prev.push({ id: facet.attribute, value: attribute.value, type: facet.type });
        }
        return prev;
    }, []);
};

/**
 * getAlgoliaFilters
 * Returns a subset of the algolia search paramaters.
 * This function returns the `filters` and the `optionalFilters`
 */
var getAlgoliaFilters = function (product, facets, activeSku, locale) {
    /**
     * Get all the sku's from the product
     * Create a filter string that excludes these skus from the result e.g:
     * `NOT masterVariant.sku:sku1 AND NOT masterVariant.sku:sku2`
     */
    var masterVariantSku = { id: 'masterVariant.sku', value: product.masterVariant.sku };
    var variantSkus = product.variants.map(function (variant) { return ({
        id: 'masterVariant.sku',
        value: variant.sku,
    }); });
    var excludedSkus = createAlgoliaFilters(__spreadArray([masterVariantSku], __read(variantSkus)), AlgoliaFilterOperator.AND_NOT, AlgoliaFilterOperator.NOT);
    /**
     * Retrieve all the attributes from the product
     * The product attributes are checked against the facets,
     * if they exist in the facets, they will be returned.
     */
    var variant = Helpers.getActiveVariant(product, activeSku);
    var attributes = getProductAttributesByFacets(facets, getLocalizedAttributes(variant.attributes, locale), locale);
    /**
     *  Create strict filters, if there are no strict filters, use only the skus
     */
    var strictAttributes = attributes.filter(function (attribute) { return attribute.type === 'strict'; });
    var filters = strictAttributes.length > 0
        ? createAlgoliaFilters(strictAttributes, AlgoliaFilterOperator.AND) + " " + AlgoliaFilterOperator.AND + " " + excludedSkus
        : excludedSkus;
    /**
     *  Create optional filters
     */
    var optionalAttributes = attributes.filter(function (attribute) { return attribute.type === 'optional'; });
    var optionalFilters = createAlgoliaFilters(optionalAttributes);
    return { filters: filters, optionalFilters: optionalFilters };
};

var CrossSellProducts = function (_a) {
    var formatProductUrl = _a.formatProductUrl, algoliaConfig = _a.algoliaConfig;
    var facets = algoliaConfig.facets;
    var _b = useProductDetailContext(), activeSku = _b.activeSku, product = _b.product, productType = _b.productType, activeVariant = _b.activeVariant, staticsUrl = _b.staticsUrl;
    var _c = useIntl(), currency = _c.currency, locale = _c.locale, getLabel = _c.getLabel;
    var _d = React.useMemo(function () { return getAlgoliaFilters(product, facets, activeSku, locale); }, [product, facets, activeSku, locale]), filters = _d.filters, optionalFilters = _d.optionalFilters;
    // QueryParamaters to be sent to Algolia
    var searchOptions = React.useMemo(function () {
        var ruleContexts = [
            "cs-" + productType,
            "cs-" + activeSku,
            "cs-" + replaceWhitespace(activeVariant.brand, '_'),
        ];
        if (CommerceToolsApi.isLenses(activeVariant)) {
            ruleContexts.push("cs-" + replaceWhitespace(activeVariant.lensType, '_'));
            activeVariant.replacementFrequency &&
                ruleContexts.push("cs-" + replaceWhitespace(activeVariant.replacementFrequency, '_'));
        }
        return {
            filters: filters,
            optionalFilters: optionalFilters,
            hitsPerPage: 10,
            ruleContexts: ruleContexts,
        };
    }, [filters, optionalFilters, productType, activeSku, activeVariant]);
    var _e = useAlgoliaSearch(algoliaConfig, searchOptions), result = _e.result, isLoading = _e.isLoading, hasError = _e.hasError;
    var isVisible = result.length > 0 && !isLoading && !hasError;
    var showLoader = result.length === 0 && isLoading;
    var handleImpression = React.useCallback(function (product, position) {
        DataLayer.pushEvent(createImpressionEvent(product, position, 'cross-sell recommendation pdp', currency));
    }, [currency]);
    var handleInteraction = React.useCallback(function (product, position) {
        DataLayer.pushEvent(createInteractionEvent(product, position, 'cross-sell recommendation pdp', currency));
    }, [currency]);
    return showLoader || isVisible ? (React.createElement("div", { className: "cross-sell-products", "data-t": "cross-sell-products" },
        React.createElement(Container, null,
            React.createElement(Heading, { component: "h2", variant: "medium" }, getLabel('products.crossSell.title')),
            React.createElement(ProductBannerView, { products: result, formatProductUrl: formatProductUrl, staticsUrl: staticsUrl, isLoading: isLoading, onProductImpression: handleImpression, onProductInteraction: handleInteraction })))) : null;
};
var CrossSellProducts$1 = withLazyLoading(CrossSellProducts);

export { AlgoliaAnalytics, AlgoliaConfigProvider, AlgoliaSearch, ConnectedProductListing$1 as ConnectedProductListing, CrossSellProducts$1 as CrossSellProducts, SortBy$1 as CustomSortBy, FacetId, FacetsDesktop, FacetsMobile$1 as FacetsMobile, NoResults, PrimaryFacets, ProductSuggestionContainer as ProductSuggestion, QueryAlgoliaProducts, SearchBar$1 as SearchBar, SearchBox$1 as SearchBox, SearchPageHeader, SearchSuggestion, SortBy$1 as SortBy, StoreSuggestion, SuggestionBlock, VirtualFacets, fetchAlgoliaConfig, isFacetHidden, isFacetVisible, isValidAlgoliaSearchConfig, useAlgoliaConfig };
//# sourceMappingURL=index.js.map
